module.exports = __webpack_public_path__ + "static/media/barack_obama.19a91cae.jpg";